import { useState } from 'react';
import { ChangeLanguage, getCurrentLanguage, type LanguageConfig, languages } from './localization';

export function LanguageDropdown() {
    const [showDropdown, setShowDropdown] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState(getCurrentLanguage());

    function onBtnClicked() {
        setShowDropdown(!showDropdown);
    }

    function onLanguageClicked(language: LanguageConfig) {
        ChangeLanguage(language);
        setCurrentLanguage(language);
        setShowDropdown(false);
    }

    return (
        <div className="relative">
            <button
                onClick={onBtnClicked}
                className="flex h-9 w-9 items-center justify-center rounded-full border border-white/30 bg-white/10 text-base text-white transition hover:bg-white/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
                type="button"
            >
                {currentLanguage?.icon}
            </button>
            <div className={`absolute right-0 z-50 mt-2 ${showDropdown ? 'scale-y-100 opacity-100 pointer-events-auto' : 'scale-y-0 opacity-0 pointer-events-none'} origin-top transition-all shadow-lg`}>
                <ul className="min-w-45 overflow-hidden rounded-2xl border border-white/40 bg-white/95 text-sm font-medium text-foreground backdrop-blur">
                    {languages.map((lang) => (
                        <li key={lang.code}>
                            <button
                                onClick={() => onLanguageClicked(lang)}
                                className="flex w-full items-center justify-between gap-2 px-3 py-2 text-left transition hover:bg-muted/60"
                            >
                                <span>{lang.display}</span>
                                <span className="text-base">{lang.icon}</span>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
